module["exports"] = [
  "Gruppen",
  "AS",
  "ASA",
  "BA",
  "RFH",
  "og Sønner"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/company/suffix.js
// module id = 1010
// module chunks = 0